import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import queryparse from 'tricks/string/queryparse';
export function getIsActiveTabFromParams(_ref) {
  var location = _ref.location,
    tabName = _ref.tabName;
  var searchParams = queryparse(location.search);
  var tab = searchParams.tab || 'details'; // Default to 'details' if no tab is specified

  return tab === tabName;
}